<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer014">
<p class="normal5"><span class="charoverride7"><br class="calibre7"/></span></p>
<p class="normal5"><span class="charoverride7">No man is lonely while eating spaghetti. </span></p>
<p class="normal6"><span class="charoverride8">—Robert Morley</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?aa2e7a46